// Passion Project Template
export const passionProjectTemplate = {
  id: 'passionProject',
  title: 'Passion Project',
  description: 'Great for showcasing intellectual curiosity, sustained commitment, creative pursuits, or community initiatives',
  sections: [
    {
      id: 'the_spark',
      label: 'The Spark',
      type: 'opening',
      prompt: 'What specific moment ignited your deep interest in this area?',
      coachVoice: "I don't want 'I've always loved...' Give me the exact moment when casual interest became genuine passion.",
      sample: "I was helping my grandmother organize old photos when I found a stack of letters written in Bengali - my own family's history that I couldn't read. The frustration of being disconnected from my own story hit me like a physical ache.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'going_deeper',
      label: 'Going Deeper',
      type: 'commitment',
      prompt: 'How did you move beyond surface-level interest? What did you do that showed real commitment?',
      coachVoice: "Anyone can say they're passionate. Show me the work. What did you sacrifice or prioritize to pursue this?",
      sample: "I spent my summer job money on Bengali language software and convinced my mom to video call my relatives in Dhaka every weekend for practice conversations. When my friends were at beach parties, I was hunched over Google Translate, slowly working through those family letters.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'your_innovation',
      label: 'Your Innovation',
      type: 'approach',
      prompt: 'What unique approach, perspective, or contribution did you bring to this area?',
      coachVoice: "What did you create or discover that wouldn't exist without YOUR specific interest and approach?",
      sample: "I realized other second-generation immigrants faced the same language barrier, so I created a 'Heritage Language Exchange' at school - Bengali students taught Urdu students, Korean students taught Spanish students. We weren't just preserving languages; we were trading cultural access.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'the_impact',
      label: 'The Impact',
      type: 'growth',
      prompt: 'How has this passion shaped who you are and what you want to do? Give concrete evidence.',
      coachVoice: "Don't just say it changed your career goals. Show me how this passion influences your daily decisions and future plans.",
      sample: "I now automatically notice language barriers everywhere - in hospitals, at parent-teacher conferences, in legal offices. I'm planning to study linguistics and public policy because I've seen how language access affects everything from healthcare outcomes to civic participation.",
      minWords: 80
    }
  ]
};